
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGamePlayerInformationArrayView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationArrayView'
import {UIGamePlayerInformationView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationView'
import {GameStateEnums} from '../../../../../shared/GameEnums'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {UIUtilsEjsVariables} from '../../../../shared/scripts/UIUtilsEjsVariables'

export class UIWGamePlayerInformationArrayView extends UIGamePlayerInformationArrayView {
    constructor(uiGameManager: UIGameManager, playerInformation: UIGamePlayerInformationView) {
        const playerInformationW = playerInformation.width
        const playerInformationH = playerInformation.height

        const bottomPlayerColor = uiGameManager.gameController.isPlayerSpectator ? uiGameManager.gameController.playOrder[0] : uiGameManager.gameController.myColor
        const isMyPlayer = playerInformation.player.color == bottomPlayerColor

        const x = playerInformationW * 0.9512
        const y = isMyPlayer ? playerInformationH * 0.5222 : playerInformationH * 0.2586
        const w = playerInformationW * 0.0447
        const h = isMyPlayer ? playerInformationH * 0.3111 : playerInformationH * 0.4828

        super(uiGameManager, playerInformation, x, y, w, h)
    }

    protected setInformationArrayArrowInteractionEvents() {
        const trigger = UIUtilsEjsVariables.isUserOnMobile ? 'touchstart' : 'pointerover'

        this.informationArrayArrow.on(trigger, (event) => {
            this.uiGameManager.eventController.sendEvent(this.playerInformation, UIGameEventEnums.HoveredOverPlayerInformationArrow)
        })

        if(!UIUtilsEjsVariables.isUserOnMobile) return
        const mapView = this.uiGameManager.mapController.mapView
        mapView.on('pointerdown', this.mapPointerListener)
    }
}
